import { DatePicker, Form, FormItemProps } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import classNames from "clsx";
import type { Dayjs } from "dayjs";
type RangeValue<T> = [T | null, T | null] | null;

import { SizeEnum } from "@/types";
import { REQUIRED_VALIDATION_MESSAGE } from "@/utils/constant";

const { RangePicker } = DatePicker;

interface DateRangeInputProps extends FormItemProps {
  name: string;
  label: string;
  placeholder: [string, string];
  size?: SizeEnum;
  required?: boolean;
  disabled?: boolean;
  hideClear?: boolean;
  isSeperator?: boolean;
  disabledDate?: (currentDate: Dayjs) => boolean;
  onChangeListener?: (val: RangeValue<Dayjs>) => void;
}

export const DateRangeInput = ({
  name,
  label,
  placeholder,
  size = SizeEnum.large,
  required = false,
  hideClear = false,
  isSeperator = false,
  disabledDate,
  onChangeListener,
  rules = [],
  ...rest
}: DateRangeInputProps) => {
  const getRules = () => {
    return [...rules, { required, message: REQUIRED_VALIDATION_MESSAGE }];
  };

  return (
    <div
      className={classNames(
        "custom_form_comp_wrapper",
        rest?.hidden && "h-0 overflow-hidden",
        isSeperator && "flex items-center gap-x-2"
      )}
    >
      <label
        htmlFor={name}
        className={classNames(
          "block text-primary-0",
          isSeperator ? "mb-6" : "mb-2"
        )}
      >
        {label}
      </label>
      {isSeperator && (
        <div className="mb-6 flex-[1] basis-40 border border-dashed border-disabled" />
      )}
      <div className={classNames(isSeperator && "basis-[288px]")}>
        <Form.Item name={name} rules={getRules()} {...rest}>
          <RangePicker
            size={size as SizeType}
            placeholder={placeholder}
            format="MMM DD, YYYY"
            disabled={rest?.disabled}
            allowClear={!hideClear}
            disabledDate={disabledDate}
            onChange={onChangeListener}
            className="w-full"
          />
        </Form.Item>
      </div>
    </div>
  );
};
